import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FunctionService} from '@app/services/functioninfo/function.service';
import {Function} from '@app/models/help/function.model'
import {PageContentFunction} from "@app/models/help/pagecontentfunction.model";
import {DataType} from "@app/models/shared/datatype.enum";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-function-select',
  templateUrl: './function-select.component.html',
  styleUrls: ['./function-select.component.scss']
})
export class FunctionSelectComponent implements OnInit {

  @ViewChild('functionTable', { static: true }) protected tableElement: ElementRef;
  @Output() functionsAdded = new EventEmitter<PageContentFunction[]>();
  @Output() closeModalClicked = new EventEmitter();

  public filterColumnText: string;
  public page = 1;
  public itemsPerPage = 10;
  public maxSize = 10;
  public numPages = 1;
  public length = 0;
  public paginationEnabled = false;

  public rows: Function[];

  public isCheckAll: boolean = false;

  //all loaded functions
  private allFunctions: Function[];

  //filtered functions specific for page content
  private filteredFunctionsForPageContent: Function[];

  //filtered functions
  private functionList: Function[];

  private excludedPageContentFunctions: PageContentFunction[];

  constructor(private functionService: FunctionService, private toasterService: ToastrService) {

  }

  ngOnInit() {
    this.loadFunctionsFromDb();
  }

  private loadFunctionsFromDb() {
    this.functionService.listForHelp().subscribe(result => {
      this.allFunctions = result;
      if (this.functionList){
        this.functionList = this.functionList.map(x => {
          x.isChecked = false;
          return x;
        });
      }
    });
  }

  private clearState(cleanFilterText: boolean = true) {
    this.length = this.functionList ? this.functionList.length : 0;
    this.paginationEnabled = this.functionList && this.functionList.length > 0;
    this.isCheckAll = false;
    if (cleanFilterText) {
      this.filterColumnText = null;
    }
    this.page = 1;
  }

  public setComponentData(excludedFunctions: PageContentFunction[]) {
    this.excludedPageContentFunctions = excludedFunctions;
    this.allFunctions.forEach(p => p.isChecked = false);
    this.filteredFunctionsForPageContent = this.allFunctions.filter(p => !this.excludedPageContentFunctions.find(t => t.functionId == p.id));
    this.functionList = [...this.filteredFunctionsForPageContent];
    this.clearState();
    this.onChangeTable();
  }

  public changePage(page: any, data: Array<any> = this.functionList): Array<any> {
    const start = (page.page - 1) * page.itemsPerPage;
    const end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public updateFunctionFilter(event) {
    if (!this.filterColumnText) {
      this.functionList = [...this.filteredFunctionsForPageContent];
    }
    else{
      this.functionList = [...this.filteredFunctionsForPageContent.filter(p => p.categoryName.toLowerCase().indexOf(this.filterColumnText.toLowerCase()) >= 0 || p.functionName.toLowerCase().indexOf(this.filterColumnText.toLowerCase()) >= 0)];
    }
    this.clearState(false);
    this.onChangeTable();
  }

  public onChangeTable(page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
    this.rows = page ? this.changePage(page, this.functionList) : this.functionList;
    this.length = this.functionList.length;
  }

  public addSelectedFunctions() {
    let pageContentFunctions: PageContentFunction[] = [];
    this.functionList.forEach($function => {
      if ($function.isChecked) {
        let pageContentFunction = new PageContentFunction();
        pageContentFunction.categoryName = $function.categoryName;
        pageContentFunction.functionName = $function.functionName;
        pageContentFunction.functionId = $function.id;
        pageContentFunction.dataType = DataType.New;
        pageContentFunctions.push(pageContentFunction);
      }
    });
    if (pageContentFunctions.length <= 0) {
      this.toasterService.warning('Please select at least one function.', 'Warning');
      return;
    }
    this.functionsAdded.emit(pageContentFunctions);
  }

  public showAddSelectedButton() {
    if (!this.functionList) {
      return false;
    }
    const selectedFunctions = this.functionList.filter(x => x.isChecked);
    return (selectedFunctions && selectedFunctions.length > 0);
  }

  public selectAll() {
    this.rows.forEach(x => {
      x.isChecked = this.isCheckAll;
    });
  }

  public getSelectedCountText() {
    if (!this.allFunctions || this.allFunctions.length <= 0) {
      return null;
    }
    let selectedItems = this.allFunctions.filter(p => p.isChecked);
    if (!selectedItems || selectedItems.length <= 0) {
      return null;
    }
    if (selectedItems.length == 1) {
      return '1 function selected';
    }
    return selectedItems.length + ' functions selected';
  }

  public unSelectAll($event) {
    $event.preventDefault();
    this.allFunctions.forEach(x => {
      x.isChecked = false;
    });
    this.allFunctions.forEach(p => p.isChecked = false);
    this.isCheckAll = false;
  }
}
